import { createStatusOptions } from '@/config/statusOptions';

// The server's `orderStatus` — legacy REJECTED rows arrive as CANCELLED. No @carboledger/ui import here — see orderStatusTone.js.
export const ORDER_STATUS = Object.freeze({
  active: 'ACTIVE',
  closed: 'CLOSED',
  cancelled: 'CANCELLED',
});

// The same stored status as the detail header's `status`, so it shares that vocabulary's labels.
const LABEL_KEYS = Object.freeze({
  [ORDER_STATUS.active]: 'ORDERS_DETAIL_STATUS_ACTIVE',
  [ORDER_STATUS.closed]: 'ORDERS_DETAIL_STATUS_CLOSED',
  [ORDER_STATUS.cancelled]: 'ORDERS_DETAIL_STATUS_CANCELLED',
});

export const {
  statusLabel: orderStatusLabel,
  buildStatusVariants,
  buildStatusFilterOptions,
} = createStatusOptions(LABEL_KEYS);
